/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_UnavailableInputs */

const id_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest ini tidak dapat dibandingkan`)
};

const ms_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifes ini tidak boleh dibandingkan`)
};

const da_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette manifest kan ikke sammenlignes`)
};

const de_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Manifest ist nicht vergleichbar`)
};

const en_us2_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This manifest is not comparable`)
};

const es_es2_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este manifiesto no se puede comparar`)
};

const es_mx2_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este manifiesto no se puede comparar`)
};

const fil_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi maihahambing ang manifest na ito`)
};

const fr_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce manifeste n’est pas comparable`)
};

const it_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo manifest non è confrontabile`)
};

const hu_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a manifest nem hasonlítható össze`)
};

const nl_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit manifest is niet vergelijkbaar`)
};

const no_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette manifestet kan ikke sammenlignes`)
};

const pl_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tego manifestu nie można porównać`)
};

const pt_br2_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este manifesto não é comparável`)
};

const pt_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este manifesto não é comparável`)
};

const ro_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acest manifest nu poate fi comparat`)
};

const fi_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tätä manifestia ei voi verrata`)
};

const sv_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det här manifestet kan inte jämföras`)
};

const vi_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể so sánh manifest này`)
};

const tr_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu manifest karşılaştırılamaz`)
};

const cs_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento manifest nelze porovnat`)
};

const bg_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Този манифест не може да се сравнява`)
};

const ru_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот манифест нельзя сравнить`)
};

const uk_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей маніфест не можна порівняти`)
};

const ar_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا البيان غير قابل للمقارنة`)
};

const hi_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस मेनिफ़ेस्ट की तुलना नहीं की जा सकती`)
};

const th_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถเปรียบเทียบแมนิเฟสต์นี้ได้`)
};

const ja_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このマニフェストは比較できません`)
};

const zh_cn2_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此清单无法比较`)
};

const zh_hant1_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此資訊清單無法比較`)
};

const ko_builds_comparison_unavailable = /** @type {(inputs: Builds_Comparison_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 매니페스트는 비교할 수 없음`)
};

/**
* | output |
* | --- |
* | "This manifest is not comparable" |
*
* @param {Builds_Comparison_UnavailableInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_unavailable = /** @type {((inputs?: Builds_Comparison_UnavailableInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_UnavailableInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_unavailable(inputs)
	if (locale === "ms") return ms_builds_comparison_unavailable(inputs)
	if (locale === "da") return da_builds_comparison_unavailable(inputs)
	if (locale === "de") return de_builds_comparison_unavailable(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_unavailable(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_unavailable(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_unavailable(inputs)
	if (locale === "fil") return fil_builds_comparison_unavailable(inputs)
	if (locale === "fr") return fr_builds_comparison_unavailable(inputs)
	if (locale === "it") return it_builds_comparison_unavailable(inputs)
	if (locale === "hu") return hu_builds_comparison_unavailable(inputs)
	if (locale === "nl") return nl_builds_comparison_unavailable(inputs)
	if (locale === "no") return no_builds_comparison_unavailable(inputs)
	if (locale === "pl") return pl_builds_comparison_unavailable(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_unavailable(inputs)
	if (locale === "pt") return pt_builds_comparison_unavailable(inputs)
	if (locale === "ro") return ro_builds_comparison_unavailable(inputs)
	if (locale === "fi") return fi_builds_comparison_unavailable(inputs)
	if (locale === "sv") return sv_builds_comparison_unavailable(inputs)
	if (locale === "vi") return vi_builds_comparison_unavailable(inputs)
	if (locale === "tr") return tr_builds_comparison_unavailable(inputs)
	if (locale === "cs") return cs_builds_comparison_unavailable(inputs)
	if (locale === "bg") return bg_builds_comparison_unavailable(inputs)
	if (locale === "ru") return ru_builds_comparison_unavailable(inputs)
	if (locale === "uk") return uk_builds_comparison_unavailable(inputs)
	if (locale === "ar") return ar_builds_comparison_unavailable(inputs)
	if (locale === "hi") return hi_builds_comparison_unavailable(inputs)
	if (locale === "th") return th_builds_comparison_unavailable(inputs)
	if (locale === "ja") return ja_builds_comparison_unavailable(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_unavailable(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_unavailable(inputs)
	return ko_builds_comparison_unavailable(inputs)
});
export { builds_comparison_unavailable as "builds.comparison.unavailable" }